import { computed, shallowReactive, type ComputedRef } from 'vue'
import { useWindow, type UseWindow } from './useWindow'
import type { FloatingWindowConfig } from '../types'
import { UIDGenerator } from 'math'

export type UseWindows = {
  windows: ComputedRef<UseWindow[]>
  push: (cfg: FloatingWindowConfig) => void
}

const state = shallowReactive<{
  windows: UseWindow[]
}>({
  windows: []
})

const uidGen = UIDGenerator({
  uidLength: 16
})
const windows = computed(() => state.windows)
export const useWindows = (): UseWindows => {
  const closeWindow = (uid: string) => {
    state.windows = state.windows.filter((it) => it.window.value.uid !== uid)
  }

  const push = (cfg: FloatingWindowConfig) => {
    const uid = uidGen.next()
    state.windows = [
      ...state.windows,
      useWindow({
        window: {
          ...cfg,
          onClose: () => {
            if (cfg.onClose) {
              cfg.onClose()
            }
            closeWindow(uid)
          }
        },
        uid
      })
    ]
  }

  return { windows, push }
}
